import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/belepes"); return; }
    (async () => {
      try {
        const u = await googleLogin(decodeURIComponent(match[1]));
        window.history.replaceState(null, "", window.location.pathname);
        navigate(u.role === "admin" ? "/admin" : "/profil");
      } catch {
        setError(true);
      }
    })();
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center gap-6">
      <Logo className="h-12 w-auto" />
      {error ? (
        <div className="text-center">
          <p className="text-sm text-ink">A bejelentkezés nem sikerült.</p>
          <button onClick={() => navigate("/belepes")} className="mt-3 text-poppy text-sm underline">Vissza a belépéshez</button>
        </div>
      ) : (
        <p className="text-sm text-inkmuted animate-pulse">Bejelentkezés folyamatban...</p>
      )}
    </div>
  );
}
